import {
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { TermsVersion } from "../../types/terms";
import TermsContentScroll from "./TermsContentScroll";

interface PaymentTermsConsentProps {
  terms: TermsVersion | null;
  loading?: boolean;
  agreed: boolean;
  onAgreedChange: (agreed: boolean) => void;
  signerName?: string;
}

const PaymentTermsConsent = ({
  terms,
  loading,
  agreed,
  onAgreedChange,
  signerName,
}: PaymentTermsConsentProps) => {
  if (loading) {
    return (
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={24} data-testid="payment-terms-loading" />
      </Box>
    );
  }

  if (!terms) {
    return null;
  }

  return (
    <Box
      data-testid="payment-terms-consent"
      sx={{
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography variant="subtitle1" gutterBottom>
        Payment Terms & Conditions
        {terms.version ? ` · Version ${terms.version}` : ""}
      </Typography>
      {signerName ? (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Accepting as {signerName}
        </Typography>
      ) : null}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          mb: 1.5,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TermsContentScroll
          testId="payment-terms-content"
          html={terms.sanitizedContent || ""}
        />
      </Box>
      <FormControlLabel
        sx={{
          mt: "auto",
          pt: 1.5,
          flexShrink: 0,
          alignItems: "flex-start",
          borderTop: 1,
          borderColor: "divider",
        }}
        control={
          <Checkbox
            checked={agreed}
            onChange={(event) => onAgreedChange(event.target.checked)}
            inputProps={{ "aria-label": "agree-to-payment-terms" }}
          />
        }
        label="I have read and agree to the Payment Terms & Conditions."
      />
    </Box>
  );
};

export default PaymentTermsConsent;
